import sendRequest from "../fetch"
import api from '../url'
import Qs from 'qs'
import { cleanParams } from "@/utils";
import downloadFile from "../download";
import { localTime } from "@/utils/utils.js";


const _base = "zxStudentHomework/";

// 学生作业 - 获取学生作业列表
export const homeWorkPage = params => {
         let _params = cleanParams(params);
         return sendRequest(api.url + _base + "page", {
           data: _params,
           method: "GET"
         });
       };

// 学生作业 - 保存课后作业
export const saveHomework = params => {
         let _params = cleanParams(params);
         return sendRequest(api.url + _base + "saveHomework", {
           data: _params,
           method: "POST"
         });
       };
// 学生作业 - 提交课后作业
export const submitHomework = params => {
         let _params = cleanParams(params);
         return sendRequest(api.url + _base + "submitHomework", {
           data: _params,
           method: "POST"
         });
       };
// 学生作业 - 提交课后作业
export const homeworkView = params => {
         let _params = cleanParams(params);
         return sendRequest(api.url + _base + "view", {
           data: _params,
           method: "GET"
         });
       };



// WEBPACK FOOTER //
// ./src/fetch/api/homework.js